import { render, staticRenderFns } from "./Mito.vue?vue&type=template&id=5f88428d"
import script from "./Mito.vue?vue&type=script&lang=js"
export * from "./Mito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports